import { axios, axiosWithRetry } from '../../shared/lib/axios'
import _ from 'lodash'
import Parse from 'url-parse'
import { creators as coreCreators, SHOW_NETWORK_ISSUE_MODAL } from '../../client/actions'

import { getQuestionAccuracy } from '../../shared/lib/calculateAccuracy'
import { createSectionArray } from '../../lcrp/lib/parse'

import { ANALYTICS_MIDDLEWARE_KEY } from '../../client/middleware/analytics'
import { TIMING_MIDDLEWARE_KEY } from '../../client/middleware/timing'
import { getCookie } from '../../client/middleware/macmillan'
import { getStudentTopicalPerformance } from '../../client/lib/macmillan'
import { store } from '../../lcrp/store/'

// subscribers
let LCRPActivityState

if (store) {
  LCRPActivityState = store.getState().core.activity.lcrp.progress
}

export function handleProgressChange () {
  const previousProgress = LCRPActivityState
  const state = store.getState()
  LCRPActivityState = state.core.activity.lcrp.progress

  if (previousProgress && !_.isEqual(previousProgress, LCRPActivityState)) {
    store.dispatch(saveLCRPActivityState(LCRPActivityState))
  }
}

export const ASSIGNMENT_READING = 'ASSIGNMENT_READING'
export function assignmentReading () {
  return {
    type: ASSIGNMENT_READING,
    [ANALYTICS_MIDDLEWARE_KEY]: ['event',
      [{ category: 'LCRP', action: 'Show Assignment Reading' }]]
  }
}

export const READING_SELECTED = 'READING_SELECTED'
export function readingSectionSelected (section) {
  return (dispatch, getState) => {
    const { activity, uiState } = getState().core

    // Only select relevant properties from secton & activity objects to pass to bootleg analytics
    const sectionAnalytics = _.pick(section, ['ebookUrl', 'label', 'sectionIdInt', 'topicIdInt'])
    const activityData = _.pick(activity, ['activityTitle', 'bookId'])
    Object.assign(sectionAnalytics, activityData)

    let endTimeVal = 0
    if (uiState.selectedReadingTimestamp !== undefined) {
      endTimeVal = new Date().getTime() - uiState.selectedReadingTimestamp
    }
    const asssignmentDate = activity.studentData.user_due_date || activity.studentData.dueDate

    const dataObj = {
      uuid: activity.config.toolInfo ? activity.config.toolInfo.uuid : 'none',
      userData: activity.studentData,
      section: sectionAnalytics,
      activityType: 'LCRP',
      studentId: activity.studentData.user_id,
      questionType: '',
      topic: activity.score.curCard &&
      activity.score.curCard.topic.label
        ? activity.score.curCard.topic.label
        : '',
      blooms: activity.score.curCard &&
      activity.score.curCard.meta.blooms
        ? activity.score.curCard.meta.blooms
        : '',
      webbs_depth_of_knowledge: activity.score.curCard && activity.score.curCard.meta.webbs_depth_of_knowledge
        ? activity.score.curCard.meta.webbs_depth_of_knowledge
        : '',
      sme_difficulty: activity.score.curCard &&
      activity.score.curCard.meta.level
        ? activity.score.curCard.meta.level
        : '',
      learning_objective: activity.score.curCard &&
      activity.score.curCard.meta.learning_objectives
        ? activity.score.curCard.meta.learning_objectives
        : '',
      dueDate: asssignmentDate || '',
      selectionTimeUTC: new Date().getTime(),
      description: 'A user has selected a required reading in LCRP to view.',
      userAction: 'LCRPSelectedReading'
    }

    if (uiState.lastSelectedSectionId !== undefined) {
      const sectionArr = createSectionArray(activity)
      let returnVal = null

      _.each(sectionArr.resultsArr, (result) => {
        if (result.type === 'section' && result.sectionId === uiState.lastSelectedSectionId) {
          returnVal = result
          return false
        }
      })
      const lastSectionAnalytics = _.pick(returnVal, ['ebookUrl', 'label', 'sectionIdInt', 'topicIdInt'])
      const activityDataForLastSection = _.pick(activity, ['activityTitle', 'bookId'])
      Object.assign(lastSectionAnalytics, activityDataForLastSection)
      if (endTimeVal > 0) {
        dataObj.lastSectionData = lastSectionAnalytics
        dataObj.lastSectionData.endTimeInMilliseconds = endTimeVal
      }
    }

    // section will only be marked as read in the reducer, after we dispatch this action
    // therefor we need to check if this section is the last one to be clicked...
    // ...and then calculate total reading time
    let counter = 1
    _.each(activity.lcrp.progress.fa, (value, key) => {
      if (value !== null && value.rd === true) {
        counter++
      }
    })
    if (counter === _.size(activity.lcrp.progress.fa)) {
      dataObj.totalReadingTimeInMilliseconds = new Date().getTime() - uiState.lcrpActivityBeginTimestamp
    }
    activity.lcrp.progress.fa.totalReadingTimeInMilliseconds =
    new Date().getTime() - uiState.lcrpActivityBeginTimestamp
    dispatch({
      type: READING_SELECTED,
      value: section,
      [TIMING_MIDDLEWARE_KEY]: true,
      [ANALYTICS_MIDDLEWARE_KEY]: ['event',
        [{
          category: 'LCRP',
          action: 'Reading Section Selected',
          label: activity.config.toolInfo || 'none',
          data: dataObj
        }]]
    })
  }
}

export const CYU_READING_SELECTED = 'CYU_READING_SELECTED'
export function cyuSectionSelected (section) {
  return (dispatch, getState) => {
    const coreObj = _.cloneDeep(getState().core)
    const activity = coreObj.activity
    const oldRetakeArray = activity.lcrp.progress.ra
    // check if this is the next selected reading and log time since the first was selected
    let endTimeVal = 0
    if (coreObj.uiState.selectionTime) {
      endTimeVal = new Date().getTime() - coreObj.uiState.selectionTime
    }
    coreObj.uiState.selectionTime = new Date().getTime()
    const readingStart = coreObj.uiState.selectionTime
    const dataObj = {
      uuid: activity.config.toolInfo ? activity.config.toolInfo.uuid : 'none',
      userData: activity.studentData,
      actTitle: activity.activityTitle,
      actEndp: activity.config.file + '.txt',
      user_id: activity.studentData.user_id,
      assignmentId: activity.studentData.assignmentId,
      retakeNumber: oldRetakeArray.length + 1,
      selectionTimeUTC: readingStart
    }

    if (coreObj.uiState.lastSelectedSectionId !== undefined) {
      const sectionArr = createSectionArray(activity)
      let returnVal = null

      _.each(sectionArr.resultsArr, (result) => {
        if (result.type === 'section' && result.sectionId === coreObj.uiState.lastSelectedSectionId) {
          returnVal = result
          return false
        }
      })
      const lastSectionAnalytics = _.pick(returnVal, ['ebookUrl', 'label', 'sectionIdInt', 'topicIdInt'])
      const activityDataForLastSection = _.pick(activity, ['activityTitle', 'bookId'])
      Object.assign(lastSectionAnalytics, activityDataForLastSection)
      if (endTimeVal > 0) {
        dataObj.lastSectionData = lastSectionAnalytics
        dataObj.lastSectionData.endTimeInMilliseconds = endTimeVal
      }
    }
    dispatch({
      type: CYU_READING_SELECTED,
      payload: { section, coreObj },
      [TIMING_MIDDLEWARE_KEY]: false,
      [ANALYTICS_MIDDLEWARE_KEY]: ['event',
        [{
          category: 'LCRP',
          action: 'CYU Section Selected for completed activity',
          label: activity.config.toolInfo ? activity.config.toolInfo.uuid : 'none',
          data: dataObj
        }]]
    })
  }
}

export const LOAD_LCRP_DATA = 'LOAD_LCRP_DATA'
export function loadLCRPData (simulateRetake = 0) {
  return {
    type: LOAD_LCRP_DATA,
    value: simulateRetake,
    [ANALYTICS_MIDDLEWARE_KEY]: ['event',
      [{ category: 'LCRP', action: 'Load dummy LCRP data' }]]
  }
}

export const FIRST_ATTEMPT_COMPLETE = 'FIRST_ATTEMPT_COMPLETE'
export function firstAttemptComplete () {
  return (dispatch, getState) => {
    const activity = getState().core.activity
    const activeTopics = activity.finalScore ? activity.finalScore.topics : activity.topics
    const totalAccuracy = getQuestionAccuracy(activeTopics)
    const cyuSections = createSectionArray(activity).resultsArr
    const cyuRedSectionArray = []
    const topicAccuracyArray = []
    _.each(cyuSections, function (cyuSection, index) {
      if (cyuSection.cyuComplete !== true && cyuSection.type === 'section') {
        cyuRedSectionArray.push({
          index,
          key: cyuSection.label
        })
      }
    })
    _.each(activeTopics, function (topic, index) {
      const label = topic.label
      const totalPointsAvailable = topic.totalPointsAvailable
      const totalPointsEarned = topic.totalPointsEarned
      topicAccuracyArray.push({
        index,
        key: label,
        topicAccuracy: totalPointsAvailable ? Math.round(totalPointsEarned / totalPointsAvailable * 100) : 0
      })
    })
    dispatch({
      type: FIRST_ATTEMPT_COMPLETE,
      [ANALYTICS_MIDDLEWARE_KEY]: ['event',
        [{
          category: 'LCRP',
          action: 'First Attempt Complete',
          label: activity.config.toolInfo ? activity.config.toolInfo.uuid : 'none',
          data: {
            uuid: activity.config.toolInfo ? activity.config.toolInfo.uuid : 'none',
            userData: activity.studentData,
            actTitle: activity.activityTitle,
            actEndp: activity.config.file + '.txt',
            user_id: activity.studentData.user_id,
            assignmentId: activity.studentData.assignmentId,
            overallAccuracy: totalAccuracy,
            topicAccuracy: topicAccuracyArray,
            cyuSectionsRemaining: cyuRedSectionArray
          }
        }]]
    })
  }
}

export const ADDITIONAL_ATTEMPT_COMPLETE = 'ADDITIONAL_ATTEMPT_COMPLETE'
export function additionalAttemptComplete () {
  return (dispatch, getState) => {
    const activity = getState().core.activity
    const activeTopics = activity.topics
    const totalAccuracy = getQuestionAccuracy(activeTopics)
    const topicAccuracyArray = []
    const cyuRedSectionArray = []
    const oldRetakeArray = activity.lcrp.progress.ra
    const cyuSections = createSectionArray(activity).resultsArr
    _.each(cyuSections, function (cyuSection, index) {
      if (cyuSection.cyuComplete !== true && cyuSection.type === 'section') {
        cyuRedSectionArray.push({
          index,
          key: cyuSection.label
        })
      }
    })
    _.each(activeTopics, function (topic, index) {
      const label = topic.label
      const totalPointsAvailable = topic.totalPointsAvailable
      const totalPointsEarned = topic.totalPointsEarned
      topicAccuracyArray.push({
        index,
        key: label,
        topicAccuracy: totalPointsAvailable ? Math.round(totalPointsEarned / totalPointsAvailable * 100) : 0
      })
    })
    dispatch({
      type: ADDITIONAL_ATTEMPT_COMPLETE,
      [ANALYTICS_MIDDLEWARE_KEY]: ['event',
        [{
          category: 'LCRP',
          action: 'Additional Attempt Complete',
          label: activity.config.toolInfo ? activity.config.toolInfo.uuid : 'none',
          data: {
            uuid: activity.config.toolInfo ? activity.config.toolInfo.uuid : 'none',
            userData: activity.studentData,
            actTitle: activity.activityTitle,
            actEndp: activity.config.file + '.txt',
            user_id: activity.studentData.user_id,
            assignmentId: activity.studentData.assignmentId,
            retakeNumber: oldRetakeArray.length + 1,
            overallAccuracy: totalAccuracy,
            topicAccuracy: topicAccuracyArray,
            cyuSectionsRemaining: cyuRedSectionArray
          }
        }]]
    })
  }
}

export const OPEN_CHECK_UNDERSTANDING = 'OPEN_CHECK_UNDERSTANDING'
export function openCheckUnderstandingModal (payload) {
  return (dispatch, getState) => {
    const activity = getState().core.activity
    const asssignmentDate = activity.studentData.user_due_date || activity.studentData.dueDate
    dispatch({
      type: OPEN_CHECK_UNDERSTANDING,
      payload,
      [TIMING_MIDDLEWARE_KEY]: true,
      [ANALYTICS_MIDDLEWARE_KEY]: ['event',
        [{
          category: 'LCRP',
          action: 'Open Check Your Understanding',
          label: activity.config.toolInfo ? activity.config.toolInfo.uuid : 'none',
          data: {
            uuid: activity.config.toolInfo ? activity.config.toolInfo.uuid : 'none',
            userData: activity.studentData,
            actTitle: activity.activityTitle,
            actEndp: activity.config.file + '.txt',
            user_id: activity.studentData.user_id,
            assignmentId: activity.studentData.assignmentId,
            attemptNumber: activity.score.curCard ? activity.score.curCard.answered.length : '',
            topic: activity.score.curCard ? activity.score.curCard.topic.label : '',
            blooms: activity.score.curCard ? activity.score.curCard.meta.blooms : '',
            sme_difficulty: activity.score.curCard ? activity.score.curCard.meta.level : '',
            learning_objective: activity.score.curCard &&
        activity.score.curCard.meta.learning_objectives
              ? activity.score.curCard.meta.learning_objectives
              : '',
            dueDate: asssignmentDate,
            cyuSection: payload,
            selectionTimeUTC: new Date().getTime()
          }
        }]]
    })
  }
}

export const CLOSE_CHECK_UNDERSTANDING = 'CLOSE_CHECK_UNDERSTANDING'
export function closeCheckUnderstandingModal (activity, sections) {
  if (sections && sections.cyuSectionsRemaining === 0) {
    return {
      type: CLOSE_CHECK_UNDERSTANDING,
      [ANALYTICS_MIDDLEWARE_KEY]: ['event',
        [{
          category: 'LCRP',
          action: 'Closed check understanding and unlock LC Quiz',
          label: activity.config.toolInfo ? activity.config.toolInfo.uuid : 'none',
          data: {
            uuid: activity.config.toolInfo ? activity.config.toolInfo.uuid : 'none',
            userData: activity.studentData,
            actTitle: activity.activityTitle,
            actEndp: activity.config.file + '.txt',
            user_id: activity.studentData.user_id,
            assignmentId: activity.studentData.assignmentId
          }
        }]]
    }
  } else {
    return {
      type: CLOSE_CHECK_UNDERSTANDING
    }
  }
}

export const FETCH_QUESTION = 'FETCH_QUESTION'
export function fetchQuestion (question) {
  return {
    type: FETCH_QUESTION,
    payload: question
  }
}

export const LOG_ANALYTICS_CYU = 'LOG_ANALYTICS_CYU'

export const CHECK_ANSWER = 'CHECK_ANSWER'
export function checkAnswer (payload) {
  return (dispatch, getState) => {
    const activity = getState().core.activity
    const asssignmentDate = activity.studentData.user_due_date || activity.studentData.dueDate
    const isCorrectAnswer = parseInt(payload.answerSelected, 10) === activity.score.curCard.correctAnswerIndex
    dispatch({
      type: CHECK_ANSWER,
      payload,
      [ANALYTICS_MIDDLEWARE_KEY]: ['event',
        [{
          category: 'LCRP',
          action: 'Submit answer',
          label: activity.config.toolInfo ? activity.config.toolInfo.uuid : 'none',
          data: {
            uuid: activity.config.toolInfo ? activity.config.toolInfo.uuid : 'none',
            userData: activity.studentData,
            actTitle: activity.activityTitle,
            actEndp: activity.config.file + '.txt',
            user_id: activity.studentData.user_id,
            assignmentId: activity.studentData.assignmentId,
            attemptNumber: activity.score.curCard ? activity.score.curCard.answered.length : '',
            topic: activity.score.curCard ? activity.score.curCard.topic.label : '',
            blooms: activity.score.curCard ? activity.score.curCard.meta.blooms : '',
            sme_difficulty: activity.score.curCard ? activity.score.curCard.meta.level : '',
            learning_objective: activity.score.curCard &&
      activity.score.curCard.meta.learning_objectives
              ? activity.score.curCard.meta.learning_objectives
              : '',
            fqUid: payload.fqUid,
            questionType: payload.questionType,
            is_correct: isCorrectAnswer,
            dueDate: asssignmentDate,
            selectionTimeUTC: new Date().getTime()
          }
        }]]
    })
    if (isCorrectAnswer) {
      const cyuQuestionArray = payload.selectedSection.cyuQuestions
      const selectedCyuIndex = payload.cyuIndex
      // set this to entire section initially, just in case something goes wrong with the for loop
      let cyuQuestion = payload.selectedSection
      for (let i = 0; i < cyuQuestionArray.length; i++) {
        if (cyuQuestionArray[i].cyuIndex === selectedCyuIndex) {
          cyuQuestion = cyuQuestionArray[i]
        }
      }
      dispatch({
        type: LOG_ANALYTICS_CYU,
        payload,
        [ANALYTICS_MIDDLEWARE_KEY]: ['event',
          [{
            category: 'LCRP',
            action: 'Log correct CYU submission',
            label: activity.config.toolInfo ? activity.config.toolInfo.uuid : 'none',
            data: {
              uuid: activity.config.toolInfo ? activity.config.toolInfo.uuid : 'none',
              userData: activity.studentData,
              actTitle: activity.activityTitle,
              actEndp: activity.config.file + '.txt',
              user_id: activity.studentData.user_id,
              assignmentId: activity.studentData.assignmentId,
              attemptNumber: activity.score.curCard ? activity.score.curCard.answered.length : '',
              topic: activity.score.curCard ? activity.score.curCard.topic.label : '',
              blooms: activity.score.curCard ? activity.score.curCard.meta.blooms : '',
              sme_difficulty: activity.score.curCard ? activity.score.curCard.meta.level : '',
              learning_objective: activity.score.curCard &&
          activity.score.curCard.meta.learning_objectives
                ? activity.score.curCard.meta.learning_objectives
                : '',
              is_correct: true,
              fqUid: payload.fqUid,
              questionType: payload.questionType,
              dueDate: asssignmentDate,
              cyuQuestionInfo: { question: cyuQuestion, index: selectedCyuIndex },
              selectionTimeUTC: new Date().getTime()
            }
          }]]
      })
    }
  }
}

export const LCRP_PROGRESS_REQUEST = 'LCRP_PROGRESS_REQUEST'
export const LCRP_PROGRESS_SUCCESS = 'LCRP_PROGRESS_SUCCESS'
export const LCRP_PROGRESS_FAILURE = 'LCRP_PROGRESS_FAILURE'
export const LCRP_GET_ALL_ACTIVITIES_SUCCESS = 'LCRP_GET_ALL_ACTIVITIES_SUCCESS'
export const LCRP_GET_ALL_ACTIVITIES_FAILURE = 'LCRP_GET_ALL_ACTIVITIES_FAILURE'

// actions
export function loadLCRPActivityState (vars, cb = null) {
  return async (dispatch, getState) => {
    dispatch({ type: LCRP_PROGRESS_REQUEST })

    const { core: { config: { LC_GRADE_SERVICE_URL, FF_USE_LC_GRADE_SERVICE }}} = getState();
    const apiEndpoint = FF_USE_LC_GRADE_SERVICE === 'true' ? `${LC_GRADE_SERVICE_URL}/` : `/`;

    const endpoint = apiEndpoint + `api/v1/lcrp/student_progress?user_id=${vars.userId}` +
    `&assignment_id=${vars.assignmentId}&course_id=${vars.courseId}`

    let json

    try {
      const response = await axios.get(endpoint)
      const contentType = response.headers['content-type']

      if (!contentType || !contentType.includes('application/json')) {
        throw response.statusText
      }

      json = await response.data
      const activity = getState().core.activity
      if (activity.finalScore) {
        dispatch({
          type: LCRP_PROGRESS_SUCCESS,
          payload: json,
          [TIMING_MIDDLEWARE_KEY]: true,
          [ANALYTICS_MIDDLEWARE_KEY]: ['event',
            [{
              category: 'LCRP',
              action: 'Load progress success: completed activity',
              label: activity.config.toolInfo ? activity.config.toolInfo.uuid : 'none',
              data: {
                uuid: activity.config.toolInfo ? activity.config.toolInfo.uuid : 'none',
                userData: activity.studentData,
                actTitle: activity.activityTitle,
                actEndp: activity.config.file + '.txt',
                user_id: activity.studentData.user_id,
                assignmentId: activity.studentData.assignmentId,
                selectionTimeUTC: new Date().getTime()
              }
            }]]
        })
      } else {
        dispatch({ type: LCRP_PROGRESS_SUCCESS, payload: json })
      }
      store.subscribe(handleProgressChange)
    } catch (error) {
      console.error(error)
      return dispatch({ type: LCRP_PROGRESS_FAILURE, payload: error })
    }

    // now attempt to build fetch all activity titles from S3
    // and calculate the topical scores for each student for each activity
    // but return early if it is an instructor
    const curUrl = new Parse(window.location.href, null, true)
    const isInstructor = curUrl.query && _.get(curUrl.query, 'view', false)
    if (isInstructor) return

    try {
      const { assignmentOverview } = getState().core.courseDashboardData
      const { config } = getState().core
      const dashboardStudent = _.get(json, 'dashboardStudent', [])
      const updatedAssignmentOverview = await getStudentTopicalPerformance(dashboardStudent, assignmentOverview, config)
      dispatch({ type: LCRP_GET_ALL_ACTIVITIES_SUCCESS, payload: updatedAssignmentOverview })
      if (cb) {
        cb()
      }
    } catch (error) {
      return dispatch({ type: LCRP_GET_ALL_ACTIVITIES_FAILURE, payload: error })
    }
  }
}

export const LCRP_SAVE_REQUEST = 'LCRP_SAVE_REQUEST'
export const LCRP_SAVE_SUCCESS = 'LCRP_SAVE_SUCCESS'
export const LCRP_SAVE_FAILURE = 'LCRP_SAVE_FAILURE'

export function saveLCRPActivityState (activityState) {
  return async (dispatch, getState) => {
    const { core: { activity, config: { LC_GRADE_SERVICE_URL, FF_USE_LC_GRADE_SERVICE }}} = getState()
    // don't save progress in preview mode
    if (activity.config.isInstructorView === true || activity.config.simulateData !== undefined) {
      return Promise.reject('Preview mode: no progress saved')
    }

    dispatch({ type: LCRP_SAVE_REQUEST })

    const studentData = _.cloneDeep(activity.studentData)
    const config = _.cloneDeep(activity.config)

    const apiEndpoint = FF_USE_LC_GRADE_SERVICE === 'true' ? `${LC_GRADE_SERVICE_URL}/` : `/`;

    const endpoint = apiEndpoint + 'api/v1/lcrp/student_progress'

    try {
      const response = await axiosWithRetry({
        url: endpoint,
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        data: JSON.stringify({
          user_id: studentData.user_id,
          assignment_id: studentData.assignment_id,
          activity_state: activityState,
          resourceId: config.itemId,
          token: getCookie('id_token')
        })
      })
      const contentType = response.headers['content-type']
      const data = response.data
      if (
        !contentType.includes('application/json') ||
        data.error
      ) {
        throw new Error('unknown error')
      }
      if (data.badToken === true) {
        throw new Error('bad token')
      }

      return dispatch({ type: LCRP_SAVE_SUCCESS, payload: data })
    } catch (error) {
      console.error(error)
      dispatch({ type: SHOW_NETWORK_ISSUE_MODAL })
      return dispatch({ type: LCRP_SAVE_FAILURE, payload: { error } })
    }
  }
}

export const START_QUIZ = 'START_QUIZ'
export const QUESTION_EVENT = 'QUESTION_EVENT'
export function startQuiz () {
  return (dispatch, getState) => {
    const activity = getState().core.activity
    const dataObj = {
      uuid: activity.config.toolInfo ? activity.config.toolInfo.uuid : 'none',
      userData: activity.studentData,
      actTitle: activity.activityTitle,
      actEndp: activity.config.file + '.txt',
      user_id: activity.studentData.user_id,
      assignmentId: activity.studentData.assignmentId,
      startQuizTime: new Date().getTime()
    }
    if (activity.lcrp.progress.ra && activity.lcrp.progress.ra.length > 0) {
      dataObj.retakeNumber = activity.lcrp.progress.ra.length + 1
    }

    dispatch({
      type: START_QUIZ,
      [TIMING_MIDDLEWARE_KEY]: true,
      [ANALYTICS_MIDDLEWARE_KEY]: ['event',
        [{
          category: 'LCRP',
          action: 'Show LC Quiz',
          label: activity.config.toolInfo ? activity.config.toolInfo.uuid : 'none',
          data: dataObj
        }]]
    })

    dispatch(coreCreators.resumeActivity())
  }
}

export const PAUSE_QUIZ = 'PAUSE_QUIZ'
export function pauseQuiz () {
  return (dispatch, getState) => {
    const activity = getState().core.activity
    const dataObj = {
      uuid: activity.config.toolInfo ? activity.config.toolInfo.uuid : 'none',
      userData: activity.studentData,
      actTitle: activity.activityTitle,
      actEndp: activity.config.file + '.txt',
      user_id: activity.studentData.user_id,
      assignmentId: activity.studentData.assignmentId,
      pauseQuizTime: new Date().getTime()
    }
    if (activity.lcrp.progress.ra && activity.lcrp.progress.ra.length > 0) {
      dataObj.retakeNumber = activity.lcrp.progress.ra.length + 1
    }
    dispatch({
      type: PAUSE_QUIZ,
      [TIMING_MIDDLEWARE_KEY]: true,
      [ANALYTICS_MIDDLEWARE_KEY]: ['event',
        [{
          category: 'LCRP',
          action: 'Paused LC Quiz',
          label: activity.config.toolInfo ? activity.config.toolInfo.uuid : 'none',
          data: dataObj
        }]]
    })
  }
}

export const PREVIEW_MODE = 'PREVIEW_MODE'
export function previewMode (selection) {
  return {
    type: PREVIEW_MODE,
    value: selection,
    [ANALYTICS_MIDDLEWARE_KEY]: ['event',
      [{ category: 'LCRP', action: 'Preview Mode Selection' }]]
  }
}

export const CLOSE_ACTIVITY = 'CLOSE_ACTIVITY'
export function closeActivity () {
  return (dispatch, getState) => {
    const activity = getState().core.activity
    const isInstructor = activity.studentData.user_rights === '3_instructor' || activity.config.isInstructorView
    const actionLabel = isInstructor ? 'Exit LCRP Activity: Instructor' : 'Exit LCRP Activity'
    // only log if student has completed the activity and has selected a reading prior to exit, or instructor
    if ((activity.finalScore && getState().core.uiState.selectionTime) || isInstructor) {
      // try to get the assignment id and the user id for all scenarios; try url if not in studentData for some reason
      const curUrl = new Parse(window.location.href, null, true)
      const urlItemId = curUrl.query && curUrl.query.itemid ? curUrl.query.itemid : null
      const urlUserId = curUrl.query && curUrl.query.user_id ? curUrl.query.user_id : null
      let assignmentIdVal = activity.studentData.assignmentId ? activity.studentData.assignmentId : null
      let userIdVal = activity.studentData.user_id ? activity.studentData.user_id : null
      if (!assignmentIdVal) {
        assignmentIdVal = urlItemId !== null ? urlItemId : 'unknown'
      }
      if (!userIdVal) {
        userIdVal = urlUserId !== null ? urlUserId : 'unknown'
      }

      dispatch({
        type: CLOSE_ACTIVITY,
        [TIMING_MIDDLEWARE_KEY]: true,
        [ANALYTICS_MIDDLEWARE_KEY]: ['event',
          [{
            category: 'LCRP',
            action: actionLabel,
            label: activity.config.toolInfo ? activity.config.toolInfo.uuid : 'none',
            data: {
              uuid: activity.config.toolInfo ? activity.config.toolInfo.uuid : 'none',
              userData: activity.studentData,
              actTitle: activity.activityTitle,
              actEndp: activity.config.file + '.txt',
              user_id: userIdVal,
              assignment_id: assignmentIdVal,
              exitTimeUTC: new Date().getTime()
            }
          }]]
      })
    }
  }
}

export const LOG_SELECTED_STUDENT = 'LOG_SELECTED_STUDENT'
export function logSelectedStudent (studentObj) {
  return (dispatch, getState) => {
    const activity = getState().core.activity
    const selectedStudentTopicData = studentObj.activity_state.tp
    let totalPointsEarned = 0
    let totalPointsAvailable = 0
    let totalQuestionsReceived = 0
    selectedStudentTopicData.forEach(({ pe, pa, qr }) => {
      totalPointsEarned += pe
      totalPointsAvailable += pa
      // eslint-disable-next-line no-unused-vars
      totalQuestionsReceived += qr
    })
    studentObj.overallAccuracy = Math.round(100 * totalPointsEarned / totalPointsAvailable)

    dispatch({
      type: LOG_SELECTED_STUDENT,
      [TIMING_MIDDLEWARE_KEY]: true,
      [ANALYTICS_MIDDLEWARE_KEY]: ['event',
        [{
          category: 'LCRP',
          action: 'Instructor Selected Student',
          label: activity.config.toolInfo ? activity.config.toolInfo.uuid : 'none',
          data: {
            uuid: activity.config.toolInfo ? activity.config.toolInfo.uuid : 'none',
            userData: activity.studentData,
            actTitle: activity.activityTitle,
            actEndp: activity.config.file + '.txt',
            user_id: activity.studentData.user_id,
            assignmentId: activity.studentData.assignmentId,
            selectedStudent: studentObj,
            selectionTimeUTC: new Date().getTime()
          }
        }]]
    })
  }
}

export const LOG_VIEW_TRENDS_INSIGHTS = 'LOG_VIEW_TRENDS_INSIGHTS'
export function logViewTrendsInsights (data) {
  return (dispatch, getState) => {
    const activity = getState().core.activity
    dispatch({
      type: LOG_VIEW_TRENDS_INSIGHTS,
      [TIMING_MIDDLEWARE_KEY]: true,
      [ANALYTICS_MIDDLEWARE_KEY]: ['event',
        [{
          category: 'LCRP',
          action: `${data.action} Trends and Insights from Courseware`,
          label: _.get(activity.config, 'toolInfo.uuid', 'none'),

          data: {
            uuid: _.get(activity.config, 'toolInfo.uuid', 'none'),
            userId: data.userId,
            userData: activity.studentData,
            eventType: data.eventType,
            courseId: data.courseId,
            itemId: data.itemId
          }
        }]]
    })
  }
}

export const INSTRUCTOR_INSIGHTS_TRENDS = 'INSTRUCTOR_INSIGHTS_TRENDS'
export function instructorInsightsTrends () {
  return {
    type: INSTRUCTOR_INSIGHTS_TRENDS,
    [TIMING_MIDDLEWARE_KEY]: true,
    [ANALYTICS_MIDDLEWARE_KEY]: ['event',
      [{ category: 'Instructor', action: 'View Insights and Trends' }]]
  }
}

export const STUDENT_INSIGHTS_TRENDS = 'STUDENT_INSIGHTS_TRENDS'
export function studentInsightsTrends () {
  return (dispatch, getState) => {
    dispatch({
      type: STUDENT_INSIGHTS_TRENDS,
      [TIMING_MIDDLEWARE_KEY]: true,
      [ANALYTICS_MIDDLEWARE_KEY]: ['event',
        [{ category: 'Student', action: 'View Insights and Trends' }]]
    })
  }
}

export const actionCreators = {
  readingSectionSelected,
  assignmentReading,
  loadLCRPData,
  firstAttemptComplete,
  additionalAttemptComplete,
  openCheckUnderstandingModal,
  closeCheckUnderstandingModal,
  fetchQuestion,
  checkAnswer,
  loadLCRPActivityState,
  saveLCRPActivityState,
  cyuSectionSelected,
  startQuiz,
  previewMode,
  closeActivity,
  pauseQuiz,
  logSelectedStudent,
  logViewTrendsInsights,
  instructorInsightsTrends,
  studentInsightsTrends

}

Object.assign(actionCreators, coreCreators)
